import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Checkbox } from '@/components/ui/checkbox';

// Desplegable compacto con casillas: el botón solo muestra la cantidad para no cambiar el tamaño del formulario.
export const PeoplePicker = ({ options, value, onChange, exclude = [], noun, emptyLabel, disabled, testId }) => {
  const visible = options.filter((e) => !exclude.includes(e.employee_id));
  const n = value.length;
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <Popover>
      <PopoverTrigger asChild disabled={disabled}>
        <button type="button" className="flex h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" data-testid={testId} aria-label={noun[0]}>
          <span className={`truncate ${n ? 'text-slate-900' : 'text-slate-500'}`} data-testid={`${testId}-summary`}>
            {n ? `${n} ${n === 1 ? noun[0] : noun[1]}` : emptyLabel}
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] p-2" data-testid={`${testId}-list`}>
        {visible.length === 0 && <p className="px-1 py-1.5 text-xs text-slate-500">No hay más personas disponibles.</p>}
        <div className="max-h-44 space-y-0.5 overflow-y-auto">
          {visible.map((e) => (
            <label key={e.employee_id} className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-slate-50" data-testid={`${testId}-option-${e.employee_id}`}>
              <Checkbox checked={value.includes(e.employee_id)} onCheckedChange={() => toggle(e.employee_id)} />
              <span className="truncate">{e.full_name}</span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
